const DEFAULT_TIMEOUT_MS = 10_000;

let defaultTimeoutMs = DEFAULT_TIMEOUT_MS;

export const boundedFetch = async (input: string | URL, init: RequestInit = {}, timeoutMs: number = defaultTimeoutMs): Promise<Response> => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(new DOMException(`no answer within ${timeoutMs}ms`, 'TimeoutError')), timeoutMs);
  const forward = () => controller.abort(init.signal?.reason);
  if (init.signal?.aborted) {
    forward();
  } else {
    init.signal?.addEventListener('abort', forward, { once: true });
  }
  try {
    return await fetch(input, { ...init, signal: controller.signal });
  } finally {
    clearTimeout(timer);
    init.signal?.removeEventListener('abort', forward);
  }
};

export const __setFetchTimeoutForTests = (ms: number | null): void => {
  defaultTimeoutMs = ms ?? DEFAULT_TIMEOUT_MS;
};
